// DOCTOR REGISTRATION Wizard Store

const initialState = () => ({
  prereg: {
    personal: {
      id: "",
      firstName: "",
      lastName: "",
      email: "",
      DOB: "",
      gender: "",
      height: "",
      cellPhone: "",
      allowSMS: "",
      address_L1: "",
      address_L2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      insuranceId: "",
      insurance: "",
      groupNumber: "",
      referralNumber: "",
      insuredFirstName: '',
      insuredLastName: '',
      insuredAddress: '',
      insuredCity: '',
      insuredState: '',
      insuredZip: '',
      insuredGender: ''
    },
    medical: {
      correctiveLens: "",
      previousEyeSurgery: "",
      historyDiabetes: "",
      historyCancer: ""
    },
    personalHistory: {
      stroke: false,
      migraines: false,
      heartDisease: false,
      liverDisease: false,
      highCholesterol: false,
      highBloodPressure: false,
      other: ""
    },
    familyHistory: {
      stroke: false,
      migraines: false,
      diabetes: false,
      cancer: false,
      glaucoma: false,
      alzheimers: false,
      heartDisease: false,
      liverDisease: false,
      highCholesterol: false,
      highBloodPressure: false,
      macularDegeneration: false,
      other: ""
    },
    editInfo: {
      ID: "",
      PersonID: "",
      userID: "",
      addressID: "",
      orgId: ""
    }
  }
})

const state = initialState()

const getters = {
  ptPrereg: (state) => {
    return state.prereg
  },
  ptPersonal: (state) => {
    return state.prereg.personal
  },
  ptMedical: (state) => {
    return state.prereg.medical
  },
  ptHistory: (state) => {
    return state.prereg.personalHistory
  },
  ptFamHist: (state) => {
    return state.prereg.familyHistory
  },
  ptEditInfo: (state) => {
    return state.prereg.editInfo
  }
}

const mutations = {
  RESET_PREREG(state) {
    Object.assign(state, initialState())
  }
}

const actions = {
  clearPrereg({ commit }) {
    commit("RESET_PREREG")
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
